import styled from 'styled-components';
import { animated } from 'react-spring';

interface LogProps {
  isredcorner: string;
  isroundaction: string;
  r: number;
  g: number;
  b: number;
}

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: black;
  margin-bottom: 1%;
`;

export const HeaderText = styled.div`
  font-size: 2.5em;
`;

export const CloseModalButton = styled.button`
  all: unset;
  font-size: 2.5em;
  color: #e84e62;
  cursor: pointer;
`;

export const Container = styled(animated.div)<LogProps>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 0.5%;
  border-radius: 5px;
  font-size: 0.95em;
  flex-direction: row;
  flex-wrap: wrap;
  margin: auto;
  [class^='-menu'],
  [class*='-menu'] {
    position: relative;
  }
  &:hover {
    background: rgba(1, 1, 1, 0.5);
    cursor: pointer;
  }

  * span {
    margin: auto;
  }

  .corner {
    font-weight: bolder;
    width: 32px;
    background-color: rgba(
      ${(props) => props.r},
      ${(props) => props.g},
      ${(props) => props.b},
      1
    );
  }

  .action-stance {
    width: 32px;
    background-color: rgba(255, 171, 7, 1);
    // font-size: 0.95em;
    // font-weight: bolder;
    // color: rgba(255, 144, 0, 1);
  }

  .action-domain {
    font-size: 0.95em;
    font-weight: bolder;
    width: 32px;

    background-color: rgba(107, 121, 151, 1);
    color: rgba(142, 125, 190, 1);
  }

  .action-name {
    font-weight: bolder;
    background-color: ${(props) =>
      props.isroundaction === 'true' ? '#9CE3BD' : 'rgba(228, 233, 242, 1)'};
    color: rgba(42, 42, 42, 1);
    width: 100%;
    padding: auto;
    max-width: 216px;
  }
  .action-empty {
    font-weight: bolder;
    background-color: rgba(228, 233, 242, 1);
    color: rgba(42, 42, 42, 1);
    width: 100%;
    padding: auto;
  }
  .time {
    font-size: 1.2em;
    width: 56px;
    padding: auto;

    background-color: rgba(42, 42, 42, 1);
  }

  .logLine {
    width: 100%;
    height: 32px;

    display: flex;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: 0.4px;
  }

  .selectPart {
    width: 50%;
    color: #111;
    z-index: 10;
  }

  .remove {
    width: 32px;
    height: 32px;
    padding: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(42, 42, 42, 1);
  }

  .standing-color {
    background-color: rgba(255, 171, 7, 1);
  }

  .ground-color {
    background-color: rgba(198, 47, 255, 1);
  }

  .fence-color {
    background-color: rgba(169, 94, 19, 1);
  }

  .true-color {
    background-color: rgba(8, 185, 89, 1);
  }
  .false-color {
    background-color: rgba(255, 141, 7, 1);
  }

  .neutral-color {
    background-color: rgba(107, 121, 151, 1);
  }
`;

export const Modal = styled.dialog`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  backgroundcolor: white;
  padding: 20px;
  borderradius: 8px;
  border: none;
  boxshadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  zindex: 1000;
`;
